import { render, staticRenderFns } from "./GroupTicketBus.vue?vue&type=template&id=f80ce6cc"
import script from "./GroupTicketBus.vue?vue&type=script&lang=js"
export * from "./GroupTicketBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports